"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var ReactIconsFA = __importStar(require("react-icons/fa"));

var __1 = __importDefault(require(".."));
/**
 * Wrapper of _react-icons_ FontAwesome integration with the Stories-API styling and integration
 */


var FontAwesomeIcon = function FontAwesomeIcon(_a) {
  var name = _a.name,
      style = _a.style;
  var ReactIcon = ReactIconsFA[name];
  return react_1.default.createElement(__1.default, {
    name: name,
    source: "fa",
    style: style
  }, react_1.default.createElement(ReactIcon, null));
};

FontAwesomeIcon.propTypes = {
  /** Name of the `Icon` */
  name: prop_types_1.default.string.isRequired,

  /** Styling object of the `Icon` */
  // eslint-disable-next-line react/forbid-prop-types
  style: prop_types_1.default.object
};
FontAwesomeIcon.defaultProps = {
  style: undefined
};
exports.default = FontAwesomeIcon;